import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { isHelixOnlyHub } from 'utils/helix';
import { PROFILE_ROUTES } from 'utils/routes';
import PageSection from 'components/PageSection';
import PageBackLink from 'components/PageBackLink';
import UserPageHeader from 'components/UserPageHeader';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function SkillPageWrapper(_ref) {
  var user = _ref.user,
    fallbackLink = _ref.fallbackLink,
    children = _ref.children;
  var location = useLocation();
  var isProfilePage = location.pathname.includes(PROFILE_ROUTES.root);

  // ProfilePage already renders its own UserHeader, so skip the duplicate
  // here - this must stay keyed on the route, not on isCurrentUser, since
  // people can also view their own analysis via /people/:id.
  var showUserHeader = !isProfilePage && user;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fallbackLink && /*#__PURE__*/_jsx(PageSection, {
      flush: !showUserHeader,
      children: /*#__PURE__*/_jsx(PageBackLink, {
        fallback: fallbackLink,
        mb: showUserHeader ? '0' : 'xs',
        mt: isProfilePage && isHelixOnlyHub ? 'm' : '0'
      })
    }), /*#__PURE__*/_jsxs(PageSection, {
      flush: true,
      children: [showUserHeader && /*#__PURE__*/_jsx(UserPageHeader, _objectSpread({}, user)), children]
    })]
  });
}
export default SkillPageWrapper;